// Footer.js
export default function Footer() {
    return (
        <section className="p-10 bg-emerald-200 flex justify-center">
            <p className="font-bold">
                ©Copyright 2024. All rights are reserved by SHIVAM
            </p>
        </section>
    );
}
